import { PaintedScene } from '../PaintedScene';

export const TREELINE_PHASER_KEY = 'TreelineScene' as const;
export const TREELINE_MANIFEST_KEY = 's-313-treeline-edge' as const;

export class TreelineScene extends PaintedScene {
  constructor() {
    super(TREELINE_PHASER_KEY, TREELINE_MANIFEST_KEY);
  }
}
